/* global debounce, attachEvent */

// *******************************************************************************
// 1.0 - Add class to body after some scroll
// *******************************************************************************
function addScrollingClass() {
  const topOffert = document.documentElement.scrollTop || document.body.scrollTop;

  if (topOffert > 50) {
    document.body.classList.add('is-scrolled');
  } else {
    document.body.classList.remove('is-scrolled');
  }
}

// Debounce the function to prevent multiple executions on scroll event
const debounceScroll = debounce(() => {
  addScrollingClass();
}, 100);

window.addEventListener('scroll', debounceScroll);

// *******************************************************************************
// 2.0 - Open mobile menu
// *******************************************************************************

attachEvent('.mobile-hamburger', 'click', (ev) => {
  ev.preventDefault();

  // Open menu
  document.body.classList.toggle('is-open-menu');
  const hamburger = ev.target.closest('.mobile-hamburger');

  if (hamburger.classList.contains('is-open')) {
    hamburger.classList.remove('is-open');
    hamburger.setAttribute('aria-expanded', 'false');
  } else {
    hamburger.classList.add('is-open');
    hamburger.setAttribute('aria-expanded', 'true');
  }
});

// *******************************************************************************
// 3.0 - Open search
// *******************************************************************************
attachEvent('.open-search', 'click', (ev) => {
  ev.preventDefault();

  document.body.classList.add('is-open-search');
});
attachEvent('.close-search', 'click', (ev) => {
  ev.preventDefault();

  document.body.classList.remove('is-open-search');
});
